import { RoundSettingsComponent } from './../../leagues/league-details/round-settings/round-settings.component';
import { ManageScoreSubscriptionComponent } from '../../scoreboard/manage-score-subscription/manage-score-subscription.component';
import { environment } from './../../../environments/environment';
import { adId } from './../../../environments/environment';
import { FirebaseAnalytics } from '@capacitor-community/firebase-analytics';
import { Season } from './../../_shared/models/season.model';
import { SeasonSelectorService } from './../../_shared/components/season-selector/season-selector.service';
import { TeamDetailsService } from '../../my-teams/team-details/team-details.service';
import {
  Component,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
  inject,
  signal,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  ActionSheetController,
  AlertController,
  IonDatetime,
  IonRefresher,
  IonRouterOutlet,
  IonSegment,
  ModalController,
  NavController,
  Platform,
  PopoverController,
  RefresherCustomEvent,
} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Socket } from 'ngx-socket-io';
import { Observable, Subject, lastValueFrom } from 'rxjs';
import { delay, finalize, take, takeUntil, tap } from 'rxjs/operators';

import { CreateMatchComponent } from '../../matches/create-match/create-match.component';
import { AddCollectionDefinitionComponent } from '../add-collection-definition/add-collection-definition.component';
import { TieDetailsPopoverComponent } from '../tie-details-popover/tie-details-popover.component';

import { AuthService } from '../../auth/auth.service';
import { MatchService } from '../../_core/services/match.service';
import { TieService } from '../../_core/services/tie.service';
import { ToastService } from '../../_core/services/toast.service';

import { Match } from '../../_shared/models/match.model';
import {
  CollectionDefinition,
  CollectionValueProfile,
  Tie,
} from '../../_shared/models/tie.model';

import { App, AppState } from '@capacitor/app';

import { TieMatchListComponent } from './tie-match-list/tie-match-list.component';
import { LoaderService } from '../../_core/services/loader.service';
import { PluginListenerHandle } from '@capacitor/core';
import { TieDetailsService } from './tie-details.service';
import { DatetimeComponent } from '../../_shared/components/datetime/datetime.component';
import { Preferences } from '@capacitor/preferences';
import { SubmitScoreReportComponent } from './submit-score-report/submit-score-report.component';
import { Location } from '@angular/common';
import { roundToNearestMinutes } from 'date-fns';
import { format, utcToZonedTime } from 'date-fns-tz';
import { ThemeService } from '../../_core/services/theme.service';
import { SocketService } from '../../_core/services/socket.service';
import { User } from '../../_shared/models/user.model';
// import { AdMob, BannerAdOptions, BannerAdPosition, BannerAdSize } from '@capacitor-community/admob';

interface MatchInfo {
  match: Match;
  collectionValueProfile: CollectionValueProfile;
}
interface GroupedMatch {
  collectionDefinition: CollectionDefinition;
  matchInfos: MatchInfo[];
}

@Component({
  standalone: false,
  selector: 'app-tie-details',
  templateUrl: './tie-details.component.html',
  styleUrls: ['./tie-details.component.scss'],
})
export class TieDetailsComponent implements OnInit, OnDestroy {
  public authService = inject(AuthService);
  public location = inject(Location);
  themeService = inject(ThemeService);
  @ViewChild('startDate') startDate: IonDatetime;
  @ViewChild('segment') segmentButtons: IonSegment;
  @ViewChild('tieMatchList') tieMatchListComponent: TieMatchListComponent;

  tie: Tie;
  tieId: string;
  isLoading: boolean;
  isDeleting: boolean;
  numberOfViewers: number = 0;
  isAddingTemplate = false;

  isOwner = signal(false);
  isOfficial = false;
  isTracker: boolean;

  isHandlingInvite = false;

  lineup = [];
  groupedMatches: GroupedMatch[] = [];

  private readonly destroy$: Subject<void> = new Subject();
  isUpdatingLineup: boolean;
  listener: PluginListenerHandle;
  isTeamOwnerSide1: boolean;
  isTeamOwnerSide2: boolean;
  isLiveMatchesOnly: boolean;
  skipCache = false;

  isStreamView = false;
  broadcastDelay: number = 0;
  deviceId: string;
  startMatch: any;

  defaultBackHref: string = "ties";

  constructor(
    private tieService: TieService,
    private tieDetailsService: TieDetailsService,
    private route: ActivatedRoute,
    private modalController: ModalController,
    private popoverController: PopoverController,
    private alertController: AlertController,
    private routerOutlet: IonRouterOutlet,
    private toast: ToastService,
    private navCtrl: NavController,
    private translateService: TranslateService,
    private matchService: MatchService,
    private socket: Socket,
    private actionSheetController: ActionSheetController,
    private loaderService: LoaderService,
    private teamDetailsService: TeamDetailsService,
    private seasonSelectorService: SeasonSelectorService,
    private ngZone: NgZone,
    private socketService: SocketService,
    public platform: Platform,
  ) { }

  async ngOnInit() {
    this.isStreamView = this.location.path().includes('stream-view');
    this.tieId = this.route.snapshot.params.tieId;
    this.subscriptions();
    this.isLoading = true;
    await this.loaderService.present();
    this.deviceId = (await Preferences.get({ key: 'deviceId' }))?.value || '';
    const url = new URL(window.location.href);
    const source = url.searchParams.get("source");
    this.defaultBackHref = source ?? this.defaultBackHref;
    // await this.showAd();
    await this.getTieAllowFansToScore();
  }

  async getTieAllowFansToScore() {
    this.tieDetailsService.getTieAfterToggleAllowFansToScore().pipe(takeUntil(this.destroy$)).subscribe((allowFansToScore) => {      
      this.getTieAfterToggleAllowFansToScore();
    });
  }

  /**
   * This is used to get the tie after the allow fans to score is toggled
   */
  async getTieAfterToggleAllowFansToScore() {
    this.tie = await this.tieDetailsService.getTieInfo(
      this.tieId,
      this.skipCache,
      true,
      'tie-details-getTieInfo'
    );
  }

  async ionViewWillEnter() {
    localStorage.removeItem('redirectAfterLogin');
    this.getTie();
  }

  async ngOnDestroy() {
    // await AdMob.removeBanner();

    this.socket.emit('leave-room', this.tieId);
    this.socket.removeListener('tie-status-updated');

    this.destroy$.next();
    this.destroy$.complete();
    this.listener.remove();
  }

  // async showAd() {
  //   const options: BannerAdOptions = {
  //     adId: this.platform.is('android') ? 'ca-app-pub-3940256099942544/6300978111' : 'ca-app-pub-3940256099942544/2934735716',
  //     adSize: BannerAdSize.BANNER,
  //     position: BannerAdPosition.BOTTOM_CENTER,
  //     margin: 0
  //   };

  //   await AdMob.showBanner(options);
  // }

  async getTie(refresher?: RefresherCustomEvent) {
    this.isLoading = true;
    let cacheMap: { [key: string]: boolean } = {};
    let cacheKey: string | undefined;
    let isAuthenticated = await this.authService.isAuthenticated();
    let isAdmin = false;

    // For non logged in users, we don't need to check if they should've skipped cache
    if (isAuthenticated) {
      const authUser: User = await this.authService.getAuthUser();
      isAdmin = authUser.role?.value === 500;

      cacheKey = `tie-skipCache`;
      const storedCacheMapRaw = (await Preferences.get({ key: cacheKey })).value;
      cacheMap = storedCacheMapRaw ? JSON.parse(storedCacheMapRaw) : {};

      this.skipCache = cacheMap[this.tieId] === true || isAdmin;
    }



    this.tie = await this.tieDetailsService.getTieInfo(
      this.tieId,
      this.skipCache,
      true,
      'tie-details-getTieInfo'
    );

    this.isTeamOwnerSide1 = await this.tieDetailsService.isTeamOwner(this.tie, 0);
    this.isTeamOwnerSide2 = await this.tieDetailsService.isTeamOwner(this.tie, 1);
    this.isOwner.set(await this.tieDetailsService.isOwner(this.tie));
    this.isOfficial = await this.tieDetailsService.isOfficial(this.tie);
    this.isTracker = this.tie.trackers.some((tracker) => this.authService.authUserSignal()?._id === tracker.tracker?._id);


    if (!this.skipCache) {
      // Recheck if this user should've skipped cache
      const canSkipCacheForTie = await this.canSkipCacheForTie(this.tie);
      if (canSkipCacheForTie) {
        this.skipCache = true;
        this.tie = await this.tieDetailsService.getTieInfo(
          this.tieId,
          this.skipCache,
          true,
          'tie-details-refetch'
        );
        cacheMap[this.tieId] = true;

      } else {
        cacheMap[this.tieId] = false;
      }
      // Update the cache for the user if only they logged in
      if (cacheKey) {
        await Preferences.set({ key: cacheKey, value: JSON.stringify(cacheMap) });
      }
    }

    this.socket.emit('join-room', this.tieId);
    this.socketSubscriptions();
    this.isLiveMatchesOnly =
      (await Preferences.get({ key: `${this.tie._id}-isLiveMatchesOnly` }))
        .value === 'true';

    this.isLoading = false;
    if (refresher) refresher.detail.complete();
    this.loaderService.dismiss();

    if (environment.production && !refresher) {
      await FirebaseAnalytics.logEvent({
        name: 'Team Match',
        params: {
          side1: this.tie.sides[0]?.team?.name,
          side2: this.tie.sides[2]?.team?.name,
          tieId: this.tie._id,
          organisation: this.tie.organisations.length
            ? this.tie.organisations[0].organisationAbbreviation
            : null,
        },
      });

      if (
        this.tie.organisations.length &&
        this.tie.organisations[0].organisationAbbreviation === 'ITA'
      ) {
        await FirebaseAnalytics.logEvent({
          name: 'ITA Team Match',
          params: {
            side1: this.tie.sides[0]?.team?.name,
            side2: this.tie.sides[1]?.team?.name,
            tieId: this.tie._id,
          },
        });
      }
    }
  }

  private async canSkipCacheForTie(tie: Tie): Promise<boolean> {
    const userId = this.authService.authUserSignal()?._id;
    const userRole = this.authService.authUserSignal()?.role?.value;

    if (userRole === 500) return true;

    if (await this.tieDetailsService.isOwner(tie)) return true;

    if (await this.tieDetailsService.isOfficial(tie)) return true;

    if (tie.trackers.some(t => t.tracker?._id === userId)) return true;

    if (await this.tieDetailsService.isTeamOwner(tie, 0)) return true;

    if (await this.tieDetailsService.isTeamOwner(tie, 1)) return true;

    return false;
  }

  async presentPopover(ev?) {
    const popover = await this.popoverController.create({
      component: TieDetailsPopoverComponent,
      componentProps: {
        tie: this.tie,
      },
      event: ev,
      translucent: false,
      cssClass: 'mt-popover',
    });

    await popover.present();
    const { data } = await popover.onDidDismiss();
    if (data) {
      if (data === 'add-match-collection') this.addCollection();
      else if (data === 'subscribe-score-updates') this.subscribeToScoreUpdates();
      else if (data === 'apply-lineup') this.applyLineup();
      else if (data === 'delete') this.deleteTeamMatch();
      else if (data === 'change-datetime') this.changeDatetime();
      else if (data === 'submit-lineup') this.submitLineup();
      else if (data === 'submit-score') this.submitScore();
      else if (data === 'synchronize-rosters') await this.synchronizeRosters();
      else if (data === 'round') await this.roundSettings();
    }

    await popover.present();
  }

  private async synchronizeRosters() {
    const seasons: Season[] = (
      await lastValueFrom(
        this.seasonSelectorService.getSeasons(this.tie.organisations[0]._id)
      )
    ).data;
    const activeSeasons: Season[] = seasons.filter(
      (season) => (season.status = 'ACTIVE')
    );

    if (activeSeasons.length) {
      await this.tie.sides.map(async (side) => {
        return await lastValueFrom(
          this.teamDetailsService
            .synchronizeTeamRoster(
              side.team.teamId,
              activeSeasons[0].seasonId,
              'ITA'
            )
            .pipe(
              take(1),
              tap(async (res) => await this.toast.presentToast(res.message))
            )
        );
      });
    } else {
      await this.toast.presentDangerToast(
        'Cannot load active season. Reach out to us if this problem persists'
      );
    }
  }

  private async applyLineup() {
    const teams = this.tie.sides.map((side) => {
      return { sideNumber: side.sideNumber, name: side.team?.name };
    });
    const buttons = [];
    teams.forEach((team, i) => {
      if (
        (team.name &&
          ((this.isTeamOwnerSide1 && i === 0) ||
            (this.isTeamOwnerSide2 && i === 1))) ||
        this.isOfficial
      ) {
        buttons.push({
          text: team.name,
          handler: () => {
            actionSheet.dismiss(team.sideNumber);
          },
        });
      }
    });

    const actionSheet = await this.actionSheetController.create({
      header: this.translateService.instant('Select team'),
      buttons: buttons,
    });

    await actionSheet.present();
    const { data } = await actionSheet.onDidDismiss();

    if (data) {
      this.isUpdatingLineup = true;
      this.tieService
        .applyLineups(this.tieId, data)
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => (this.isUpdatingLineup = false))
        )
        .subscribe({
          next: (res) => {
            this.tie = res.data;
            this.toast.presentToast(res.message);
          },
        });
    }
  }

  deleteTeamMatch() {
    this.translateService
      .get([
        'Delete match',
        'Are you sure that you want to delete this match?',
        'Yes, delete',
        'No, keep it',
      ])
      .subscribe(async (translations) => {
        const alert = await this.alertController.create({
          header: translations['Delete match'],
          message:
            translations['Are you sure that you want to delete this match?'],
          buttons: [
            {
              text: translations['Yes, delete'],
              role: 'destructive',
              handler: () => {
                this.isDeleting = true;
                this.tieService
                  .delete(this.tieId)
                  .pipe(
                    takeUntil(this.destroy$),
                    finalize(() => (this.isDeleting = false))
                  )
                  .subscribe(
                    (res) => {
                      this.toast.presentToast(res.message);
                      this.tieService.publishDelete(this.tieId);
                      this.navCtrl.back();
                    },
                    (err) => {
                      //console.log(err)
                    }
                  );
              },
            },
            {
              text: translations['No, keep it'],
            },
          ],
        });

        alert.present();
      });
  }

  async addCollection() {
    const modal = await this.modalController.create({
      component: AddCollectionDefinitionComponent,
      componentProps: { tie: this.tie },
      presentingElement: this.routerOutlet.nativeEl,
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();

    if (data) {
      this.tie.tieFormat = data;
      await this.tieMatchListComponent?.getMatches();
      this.tieMatchListComponent?.getGroupedMatches();
    }
  }

  async createMatch(collectionDefinition, collectionPosition) {
    const modal = await this.modalController.create({
      component: CreateMatchComponent,
      componentProps: {
        tie: this.tie,
        collectionDefinition,
        collectionPosition,
      },
      presentingElement: this.routerOutlet.nativeEl,
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();

    if (data) {
      this.tie.matchUps.forEach((match) => {
        if (match._id === data.match._id) {
          match = data.match;
        }
      });
    }
  }

  private async updateTie(startDate) {
    this.tieService
      .update(this.tieId, { startDate })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.tie.startDate = startDate;
          this.tieService.publishEdit(this.tie);
        },
      });
  }

  async changeDatetime() {
    const popover = await this.popoverController.create({
      component: DatetimeComponent,
      componentProps: {
        dateTimeIsoString: this.tie.startDate,
      },
      translucent: false,
      cssClass: 'mt-popover',
    });

    await popover.present();

    const { data } = await popover.onDidDismiss();

    if (data) {
      this.updateTie(this.getTimeToDisplay(data));
    }
  }

  private getTimeToDisplay(data) {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const date = roundToNearestMinutes(new Date(data), { nearestTo: 30 });
    const zonedTime = utcToZonedTime(date, userTimeZone);
    return format(zonedTime, "yyyy-MM-dd'T'HH:mmXXX", {
      timeZone: userTimeZone,
    });
  }

  private socketSubscriptions() {
    this.getTieStatus()
      .pipe(takeUntil(this.destroy$))
      .subscribe((status: any) => {
        this.tie.winningSide = status.winningSide;
        this.tie.matchStatus = status.matchStatus;
        this.tie.score = status.score;
      });
    this.getMatchStartStatus();
  }

  private getTieStatus() {
    const observable = new Observable((observer) => {
      this.socket.on('tie-status-updated', (data) => observer.next(data));
    });
    return observable;
  }

  private getMatchStartStatus() {
    this.socketService
      .getSocketUpdate('match/score')
      .pipe(takeUntil(this.destroy$), delay(this.broadcastDelay * 1000))
      .subscribe(
        (data: any) => {
          if (!this.deviceId || !data.deviceId || data.deviceId !== this.deviceId) {
            this.startMatch = data;
          }
        }
      );
  }

  isScoreSmall(score: string): boolean {
    const scores = this.tieDetailsService.getScore(score);
    const left = scores[0]?.replace(' ', '').length || 0;
    const right = scores[1]?.replace(' ', '').length || 0;
    return left > 2 || right > 2;
  }

  updateMatch(updatedMatch: Match) {
    // TODO Investigate if this is needed???
    const matchIndex = this.tie.matchUps.findIndex(
      (match) => match._id === updatedMatch._id
    );
    this.tie.matchUps[matchIndex] = updatedMatch;
  }

  // This function is called from the view
  async addFromTemplate(template) {
    if (template) {
      this.isAddingTemplate = true;
      this.tieService
        .addCollectionDefinitionsFromTemplate(this.tieId, template.subtype)
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => (this.isAddingTemplate = false))
        )
        .subscribe((res) => {
          this.toast.presentToast(res.message);
          this.getTie();
        });
    }
  }

  private async subscriptions() {
    this.listener = await App.addListener(
      'appStateChange',
      async (state: AppState) => {
        // state.isActive contains the active state
        if (state.isActive) {
          /**
           * Angular change detection is not triggered when App.addListener('appStateChange', ...) 
           * runs in the background context and resumes.
           */
          this.ngZone.run(() => {
            this.getTie();
          });
        }
      }
    );

    this.matchService
      .subscribeEdit()
      .pipe(takeUntil(this.destroy$))
      .subscribe((updatedMatch) => {
        this.tieMatchListComponent.matches.forEach((match, i) => {
          if (match._id === updatedMatch._id) {
            this.tieMatchListComponent.matches[i] = updatedMatch;
            // this.orderOfFinishUpdate(updatedMatch);
          }
        });
      });
  }

  orderOfFinishUpdate(updatedMatch: Match) {
    const finishedMatches: Match[] = this.tieMatchListComponent.matches.filter(
      (m) => m.collectionId === updatedMatch.collectionId && m.winningSide > 0
    );

    finishedMatches.sort((a, b) => {
      if (new Date(a.endDate) < new Date(b.endDate)) return -1;
    });
    finishedMatches.forEach((match, i) => {
      match.orderOfFinish = i + 1;
    });

    const unfinishedMatches: Match[] =
      this.tieMatchListComponent.matches.filter((m) => !m.winningSide);

    unfinishedMatches.forEach((match) => {
      if (match.orderOfFinish) {
        match.orderOfFinish = null;
      }
    });
  }

  isAuthenticated() {
    this.getTie();
  }

  filterMatches() {
    this.tieMatchListComponent.changeIsLiveMatchesOnly();
  }

  areCollectionDefinitionsAvailable(): boolean {
    return !this.isLoading && this.tie?.tieFormat.collectionDefinitions.length
      ? true
      : false;
  }

  async submitLineup() {
    const alert = await this.alertController.create({
      header: 'Submit lineup to ITA',
      message:
        'All submitted dual match lineups to an ITA match scorecard require your verification on the ITA Team Workspace. Do you want to continue?',
      buttons: [
        {
          text: 'Yes, submit',
          handler: () => {
            this.tieDetailsService
              .submitLineup('ITA', this.tie.tieId)
              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: async (res) => {
                  await this.toast.presentToast(res.message);
                  await this.submitScore();
                },
              });
          },
        },
        {
          text: 'No',
        },
      ],
    });

    alert.present();
  }

  async submitScore() {
    this.tieDetailsService
      .getMatches(this.tieId, true)
      .subscribe(async (tieMatchUps: Match[]) => {
        const matchUpScoreValidation =
          this.tieDetailsService.validateMatchScores(tieMatchUps);

        const validMatchIds: string[] = matchUpScoreValidation
          .map((msv) => {
            if (msv.scoreIssues.length === 0) {
              return msv.matchUp.matchId;
            }
          })
          .filter((item) => typeof item === 'string');

        if (matchUpScoreValidation.some((msv) => msv.scoreIssues.length > 0)) {
          const canContinue = await this.scoreValidationReport(
            matchUpScoreValidation
          );
          if (!canContinue) return;
        }

        this.executeSubmitScore(validMatchIds);
      });
  }

  async executeSubmitScore(matchUpIds: string[]) {
    const alert = await this.alertController.create({
      header: 'Submit score to ITA',
      message:
        'After submitting your scores, please verify match results on the ITA Workspace.',
      buttons: [
        {
          text: 'Yes, submit',
          handler: () => {
            this.tieDetailsService
              .submitScore('ITA', this.tie.tieId, matchUpIds)
              .pipe(takeUntil(this.destroy$))
              .subscribe((res) => {
                this.toast.presentToast(res.message);

                this.showScoreSubmissionAlert(
                  matchUpIds.length,
                  this.tie.matchUps.length
                );
              });
          },
        },
        {
          text: 'No',
        },
      ],
    });

    alert.present();
  }

  async showScoreSubmissionAlert(sent: number, totalMatches: number) {
    const alert = await this.alertController.create({
      header: 'Score submission',
      message: `${sent} out of ${totalMatches} match scores were submitted. Verification is required in ITA workspace.`,
      buttons: [
        {
          text: 'Ok',
        },
      ],
    });

    await alert.present();
  }

  async scoreValidationReport(matchUpScoreValidation): Promise<boolean> {
    const modal = await this.modalController.create({
      component: SubmitScoreReportComponent,
      componentProps: { matchUpScoreValidation },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();

    return data;
  }

  addTieOwner() {
    this.tieDetailsService
      .addOwner(this.tie._id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: async (res) => {
          await this.toast.presentToast(res.message);
          this.tie.owners = res.data;
          this.isOwner.set(true);
        },
      });
  }

  removeTieOwner() {
    this.tieDetailsService
      .removeOwner(this.tie._id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: async (res) => {
          await this.toast.presentToast(res.message);
          this.tie.owners = res.data;
          this.isOwner.set(false);
        },
      });
  }

  async roundSettings() {
    const popover = await this.popoverController.create({
      component: RoundSettingsComponent,
      componentProps: {
        tie: this.tie,
      },
      translucent: false,
    });

    await popover.present();
  }

  async subscribeToScoreUpdates() {
    // Open the manage score subscription modal
    const modal = await this.modalController.create({
      component: ManageScoreSubscriptionComponent,
      componentProps: {
        match: this.tie, // Pass the tie as a match object
        tieId: this.tieId,
        allowSubscribingToScore: true
      },
      presentingElement: this.routerOutlet.nativeEl
    });

    await modal.present();
  }

  getAccronym(sideNumber): string {
    // Check if this.tie is an empty object
    if (this.tie && Object.keys(this.tie).length === 0) {
      return '';
    }

    if (this.tie?.sides[sideNumber - 1].team?.abbreviation) {
      return this.tie.sides[sideNumber - 1].team?.abbreviation || '';
    } else {
      return 'TBD';
    }
  }
}
